import { render, staticRenderFns } from "./WarpGlfx.vue?vue&type=template&id=721047f8"
import script from "./WarpGlfx.vue?vue&type=script&lang=js"
export * from "./WarpGlfx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports